"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var objectFieldTemplateStyles = makeStyles_1.default(function () { return ({
    root: {
        flexDirection: 'column',
    },
    child: {
        marginBottom: 20,
    },
}); }, { name: 'GqlCheckout_InStorePaymentForm_ObjectFieldTemplate' });
exports.default = objectFieldTemplateStyles;
